import { FC } from "react"

const GlobalLoader: FC = () => {
  return (
    <div id="global-loader">
      <div className="page-loader"></div>
    </div>
  )
}

export default GlobalLoader
